import React from 'react';
import { Chip, Stack } from '@mui/material';
import { IChipsList } from './interfaces';

export const ChipList: React.FC<IChipsList> = ({ chips }) => {
  return (
    <Stack rowGap="10px">
      {chips.map((chip, index) => (
        <Chip
          key={index}
          label={chip.label}
          onClick={chip.onClick}
          sx={{ width: 'fit-content' }}
          size="small"
        />
      ))}
    </Stack>
  );
};
